<template>
  <b-sidebar
    id="add-new-tag-sidebar"
    :visible="isAddNewTagSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-tag-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Agregar Nuevo Tag
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >

          <!-- Pregunta -->
          <validation-provider
            #default="validationContext"
            name="Pregunta"
            rules="required"
          >
            <b-form-group
              label="Tag"
              label-for="pregunta-tag"
            >
              <b-form-input
                id="pregunta-tag"
                v-model="tagData.nombre"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="Node"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Icono -->
          <b-form-group
            label="Icono"
            label-for="icono-tag"
          >
            <b-form-input
              id="icono-tag"
              v-model="tagData.icono"
              autofocus
              trim
              placeholder="Icono"
            />
          </b-form-group>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Guardar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
// import store from '@/store'
import { useMutation } from '@vue/apollo-composable'
// import ADD_TAG from '../../../../graphql/cursos/tag/AddTag.gql'
import ADD_TAG from '../../../../graphql/cursos/tag/AddTag.gql'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewTagSidebarActive',
    event: 'update:is-add-new-tag-sidebar-active',
  },
  props: {
    isAddNewTagSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
    }
  },
  setup(props, { emit }) {
    // Use toast
    const toast = useToast()

    const blankTagData = {
      nombre: '',
      icono: '',
    }

    const tagData = ref(JSON.parse(JSON.stringify(blankTagData)))
    const resetuserData = () => {
      tagData.value = JSON.parse(JSON.stringify(blankTagData))
    }

    const { mutate: sendtag, onDone, onError } = useMutation(ADD_TAG, () => ({
      variables: tagData.value,
    }))

    onDone(() => {
      emit('refetch-data')
    })

    onError(error => {
      toast({
        component: ToastificationContent,
        props: {
          title: error.message,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    })

    const onSubmit = () => {
      sendtag()

      emit('refetch-data')
      emit('update:is-add-new-tag-sidebar-active', false)
      /*
      store.dispatch('app-user/addUser', cursoData.value)
        .then(() => {
          emit('refetch-data')
          emit('update:is-add-new-user-sidebar-active', false)
        })
        */
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetuserData)

    return {
      tagData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
